export const bulkMintTokenContract =
  "0x0005A12fFB8edf3D93E49fEb79E3ea45883B1de2";
  export const multisendTokenContract =
  "0x89d050840d9B93AA6E5f73A350921dD1818059f7";